import { useGetQuery } from "hooks/queries"
import { SigmaWorkbook } from "../types"

export function useFetchSigmaWorkbooks(accountAlias: string): { workbooks: SigmaWorkbook[], isPending: boolean, isError: boolean, error: Error | null } {
  const { data, isPending, isError, error } = useGetQuery<{ workbooks: SigmaWorkbook[] }>({
    url: `/api/${accountAlias}/sigma/workbooks`,
  })
  return { workbooks: data?.workbooks ?? [], isPending, isError, error }
}
